<template>
  <div v-loading="loading">
    <div>
      <page-header
        title="Active Bookings"
        breadcrumb="Billings & Payments > My Transactions"
      />
    </div>

    <div class="bg-white p-3">
      <div class="flex py-4 justify-between flex-wrap">
        <div class="unit-point w-full sm:w-5/12">
          <p class="w-full">Transaction Count: {{ allbookings.totalCount }}</p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
        <div class="unit-point w-full sm:w-5/12">
          <p class="w-full">
            Total Value: ₦
            {{
              allbookings && allbookings.totalTransactionValue
                ? allbookings.totalTransactionValue.toLocaleString()
                : "0"
            }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="px-6 py-3 my-4 bg-primary-yellow"
          @click="showNewBookingModal = true"
        >
          Book New Shipment
        </button>
      </div>
      <TableFilter @filterProps="filterProps" @setSearchTerm = "sortSearchString" @setQueryparams="sortItemProps"  @appliedStatus="appliedStatus" :bookings="bookings"  />
      <bookings-table @refresh="getAllBookings" :bookings="bookings" />
    </div>
    <div class="mb-3"></div>

    <PaginationControl
      :total="bookingCount"
      :pageNumber="pageNumber"
      @pageNumber="setPageDisplay"
      @pageSize="setNumDisplay"
    />

    <NewBookinfModal
      :showModal="showNewBookingModal"
      @close-modal="showNewBookingModal = false"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import BookingsTable from "./BookingTable.vue";
import TableFilter from "./module/TableFilter.vue";
import PaginationControl from "@/components/UI/pagination";
// import debounce from "@/utilities/debounce";

import NewBookinfModal from "./modals/NewBookinfModal.vue";


export default {
  components: {
    PageHeader,
    BookingsTable,
    TableFilter,

    PaginationControl,
    NewBookinfModal,
  },
  data() {
    return {
      bookings: [],
      loading: false,
      bookingCount: 0,
      pageSize: 10,
      pageNumber: 1,
      bookingValue: {},
      showNewBookingModal: false,
      bookingTotalValue: null,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        interval: "month",
        startDate: "2025-02-25",
        endDate: "2025-02-25",
        searchString: "",
      },
    };
  },
  mounted() {
    this.getAllBookings();
    this.getPaidTransactionValue();
    },
  watch: {
    payload() {
      
      this.getAllBookings();
    },
  },
  computed: {
    PaidPayload() {
      return { paymentStatus: "paid" };
    },
    payload() {
      return {
        status: "pending",
        interval: this.sortOptions.interval,
        startDate: this.sortOptions.startDate,
        endDate: this.sortOptions.endDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        // searchString: this.sortOptions.searchString,
        shippingReference: "",
        customerType: "consumer",
      };
    },
  },
  methods: {
    filterProps(val) {
      this.sortOptions.interval = val
        this.getAllBookings();       
    },
    sortSearchString(val) {  
      if (val.length === 6 ) {
        this.payload.shippingReference = val  
        this.getAllBookings(); 
      } else if (!val.length) {
        this.payload.shippingReference = ""  
        this.getAllBookings();
      }
    },
    sortItemProps(val) {
      this.payload.interval = val.interval
      this.payload.startDate = val.startDate
      this.payload.endDate = val.endDate
      this.getAllBookings(); 
    },
    appliedStatus(allbookingsVal, bookingsVal, bookingCountVal, bookingTotalValueVal) {
      this.allbookings = allbookingsVal;
      this.bookings = bookingsVal;
      this.bookingCount = bookingCountVal;
      this.bookingTotalValue = bookingTotalValueVal;
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
    bookingFlow() {
      localStorage.setItem("booking-flow-tab", 1);
      this.$router.push("/booking-flow");
    },
    async getPaidTransactionValue() {
      try {
        let response = await this.$_getPaidtransactionValue(this.PaidPayload);
        this.bookingValue = response.data.data;
      } catch (error) {
        //...code herex
      }
    },
    async getAllBookings() {
      this.loading = true;
      try {
        const response = await this.$_getActiveBookings(this.payload);
        this.allbookings = response.data.data
        this.bookings = response.data.data.allShippings;
        this.bookingCount = response.data.data?.totalCount ?? "0";
        this.bookingTotalValue = response.data.data?.totalTransactionValue ?? "0"; 
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
   
    filteredBookings(event) {
      this.bookings = event;
    },
    loadingBookings(event) {
      this.loading = event;
    },
  },
};
</script>

<style>
.unit-point {
  @apply flex items-center shadow-lg px-4 py-2 rounded-lg;
}
</style>
